import React, {Fragment} from 'react';
import {
    AutocompleteInput,
    CardActions,
    Datagrid,
    Filter,
    List,
    ReferenceInput,
    TextField,
    TextInput
} from 'react-admin';
import EduDataSync from "./EduDataSyncButton";
import {schoolYears} from "../../components";
import CardApplicationSyncButton from "./CardApplicationSyncButton";
import {EDataStatusField} from "./EDataStatus";
import {ETrangThaiHocField} from "./ETrangThaiHoc";
import EnrollmentSyncButton from "./EnrollmentSyncButton";


const PostActions = ({
                         basePath
                     }) => (
    <CardActions>
        <EnrollmentSyncButton/>
        <EduDataSync />
    </CardActions>
);

const EduFilter = (props) => (
    <Filter {...props}>
        <ReferenceInput source="unitId" reference="clazzes" alwaysOn allowEmpty label={'Lớp'}
                        filter={{schoolYear: (schoolYears && schoolYears.length > 0) ? schoolYears[0].id : null}}
                        perPage={999}>
            <AutocompleteInput optionText="name"/>
        </ReferenceInput>
        <TextInput label="ra.action.search" source="q" alwaysOn/>
    </Filter>
);

const PostBulkActionButtons = props => (
    <Fragment>
        <CardApplicationSyncButton {...props} />
    </Fragment>
);

export const EduDataList = props => (
    <List filters={<EduFilter/>} {...props}
          bulkActionButtons={<PostBulkActionButtons/>}
          exporter={false}  actions={<PostActions/>}>
        <Datagrid rowClick="show">
            <TextField source="id"/>
            <TextField source="HO_TEN"/>
            <TextField source="NGAY_SINH"/>
            <TextField source="MA_LOP"/>
            <ETrangThaiHocField source="MA_TRANG_THAI_HIEN_TAI"/>
            <EDataStatusField source="status"/>
        </Datagrid>
    </List>
);

export default EduDataList
